export default __webpack_public_path__ + "static/Doubleday-f37a92881ddf0d60e53a6a40822a2d61.png";